export interface ICadastroFilter {
  variavelNo: number;
  value: any;
}
